<template>
    <div>
        <el-empty :description="'非常抱歉！无法找到' + desc()">
            <div>
                您可能需要帮助：
                <el-button type="text" icon="el-icon-search" @click="search">搜索菜单</el-button>
            </div>
        </el-empty>
    </div>
</template>

<script>
export default {
    name: 'indexEmpty',
    methods: {
        desc: function () {
            return this.$store.getters['etao/focusPage'] === '0' ? '页面' : `【${this.$store.getters['etao/focusPage']}】`
        },
        search: function () {
            window.focusSearch()
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/indexEmpty.vue